import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { StoryWordIndex } from '../slices/story-reading/story-reading.slice.types.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectStepAfterTransitionWord = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  ({ step }): StoryWordIndex | undefined => {
    if (step?.index === undefined || step.transitionIndex === undefined) return undefined;

    return {
      index: step.index,
      subindex: step.transitionIndex,
    };
  }
);
